$(document).ready(function(){
  
  /* product page custom slider js start */
  function pdp_slider(){
   $('.pdp_page_slider').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    infinite: true,
    dots:true,
    arrows:true,
    autoplay: false,
    prevArrow: '<button class="slide-arrow prev-arrow left-arrow-style"></button>',
    nextArrow: '<button class="slide-arrow next-arrow right-arrow-style"></button>' 
   });
  }
  pdp_slider();

  $('body').on('click','fieldset .variant-input[data-index="option1"]',function(){
  var vari_article = $(this).find('label').attr('variant-val').split('_')[0];
  customVariantImageTag();
   $(this).parents('.product-section').find('.accordian_item .second-data-text[label="Article Number "]').text(vari_article);
    let alt = $(this).find('input').val();
    alt = alt.toLowerCase().replace(/\s+/g,'-');
    const handle = $('.pdp_page_slider').attr('handle');
     $.ajax({url: "/products/"+handle+".json", 
       success: function(result){
         $('.pdp_page_slider').slick('unslick');
         $('.pdp_page_slider').html('');
          const images = result['product'].images.filter(image => {
            let alt_1 = image.alt;
            if(alt_1 != null){
              alt_1 = alt_1.toLowerCase().replace(' ','-');
              return alt_1.includes(alt)
            }
          })
         let image_html = ''
           images.forEach(function(image,i){
             image_html = image_html + `<div class="product-main-slide secondary-slide" data-index="${i}" div-alt="${image.alt}">
                <div data-product-image-main="" class="product-image-main">
                 <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
                   <img class="js-photoswipe__zoom product__photo-zoom photoswipe__image lazyautosizes lazyloaded" data-index="${i}" src="${image.src}" alt="${image.alt}">
                 </div>
                </div>
              </div>`;
           })
           $('.pdp_page_slider').html(image_html);
           pdp_slider();
        }
      });
  });  


  // Function to show/hide the variant tag container based on the metafield value
  function customVariantImageTag() {
    var vari_tag =  $('input[name="Color"]:checked').closest('.variant-input').find('label').attr('data-variant-metafield-tag-value');
    var image_container = document.querySelectorAll('#custom_left_section .pdp-variant-tags .cs-tag-container');
    if (vari_tag && vari_tag.trim() !== "") {
      image_container.forEach(function(container) {
        container.style.display = 'block';
      });
    } else {
      image_container.forEach(function(container) {
        container.style.display = 'none';
      });
    }
  }

// On page load, call the function to check and display the image container
$(document).ready(function() {
  customVariantImageTag();
});

  /* product page custom slider js end */
  
  

  // productpage slider dots js
  // setTimeout(function() {
  //   $('.product__main-photos .flickity-page-dots').show();
  // }, 2500);
  
  // you may also like section on cart drawer js
    // recomented product on cart 
                   fetch('/cart?view=recommend', {
              credentials: 'same-origin',
              method: 'GET',
            }).then(function (content) {    
              content.text().then(function (html) {
               if ($(html).find('.section_imges').length > 0) {
                  $('.border_collection_section').show();
                 $('.recommented__product_cart').html(html);
                }else{
                  $('.border_collection_section').hide();
                }
              });
            });
    // recomented product on cart end

 
 // read more and read less js of collection description 
        $('.moreless-button').click(function() {
        $('.moretext').toggleClass('addremove');
        if ($('.moreless-button').text() == "Read more") {
          $(this).text("Read less")
           $('.dots').hide();
        } else {
          $(this).text("Read more")
          $('.dots').show();
        }
   
      });
//switches hide and show on collection page
$('body').on('click', '.btn-custom.select-switchs', function() {
  // Toggle the height class on color-switch
  $(this).parents('.grid-product').find('.color-switch').toggleClass('switch-height');
  
  // Toggle visibility between the plus and minus SVG icons
  $(this).find('.icon-plus').toggle();
  $(this).find('.icon-minus').toggle();
});


   $('body').on('click','#product-add-to-cart_drawer', function() {
      $(this).parents('.crosscell_items').find('.custom-model-main11').slideToggle(500);
      })

   //collection page slider js
  $('.slider-mobile').slick({
    slidesToShow: 2.1,
    slidesToScroll: 1,
    infinite: true,
    autoplaySpeed: 3000,
    dots:false,
    arrows:false,
    autoplay: true,
    
 });

      
$('body').on('click', '.cstm_collection_add', function (event) {
  var selectedColor = event.target.closest('.grid-product__content').querySelector('.color-swatch.active');
  let color = document.querySelector('.grid-product__color-image.is-active') || selectedColor; 
  let ProductId = $(this).attr('data-id'); 

  if (color) {
      color = color.getAttribute('data-value').trim().toLowerCase().replace(" ","-"); 
      let size = $(this).text().trim(); // Make sure size is trimmed 

      // Get all the option elements from the select dropdown
      const options = this.closest("fieldset").querySelector(`option[data-color-option = '${color}'][data-size-option = '${size}']`); 
      ProductId = options.value;
  }
   
  var vdata = { quantity: 1, id: ProductId };

  // Add to cart
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: vdata,
      dataType: 'json',
      success: function (cart) {
          $.getJSON('/cart.json', function (data) {
              var item_count = data.item_count;
              $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
          });
          var cart = new theme.CartDrawer;
          cart.init();
          cart.open();
      },
      error: function () {
          alert('This combination of variant is not available please try different variants.');
      }
  });
  // End add to cart
});

// Initial Slick slider setup
function initializeSlick(slickClass) {
  const sliders = document.querySelectorAll(`.${slickClass}`);
  
  sliders.forEach(slider => {
    if ($(slider).hasClass('slick-initialized')) {
      $(slider).slick('unslick');
    }

    // Reinitialize Slick
    $(slider).slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false,
      autoplay: false
    });
  });
}

initializeSlick("custom_slider-mobile");
initializeSlick("custom-image-element-wrap");


// Function to set width and refresh Slick slider
function setWidthAndRefreshSlider(width) {
  const containers = document.querySelectorAll('.collection-content-main-container .small--one-half');
  containers.forEach(container => {
      container.style.width = width;
  });

  setTimeout(() => {
      const sliders = document.querySelectorAll('.custom_slider-mobile');
      sliders.forEach(slider => {
          $(slider).slick('setPosition');  
      });
  }, 50);
}

// Click event for the 100% width icon
const oneIcon = document.getElementById('grid-one-view');
if (oneIcon) { 
  oneIcon?.addEventListener('click', () => { 
      setWidthAndRefreshSlider('100%'); 
      initializeSlick("custom-image-element-wrap");
  });
}

// Click event for the #list-view icon: 100% on mobile, 50% on desktop
const twoIcon = document.getElementById('list-view');
if (twoIcon) {
  twoIcon?.addEventListener('click', () => {
      const isMobile = window.innerWidth <= 768;  
      setWidthAndRefreshSlider(isMobile ? '100%' : '50%');
  });
}

// Click event for the #grid-view icon: 50% only on mobile
const threeIcon = document.getElementById('grid-view');
if (threeIcon) {
  threeIcon?.addEventListener('click', () => {
      const isMobile = window.innerWidth <= 768;  
      initializeSlick("custom-image-element-wrap");
      if (isMobile) {
          setWidthAndRefreshSlider('50%');  
      }
  });
}

// 100% width is applied initially if #grid-one-view is active on page load
if (oneIcon && oneIcon.classList.contains('active')) {
  setWidthAndRefreshSlider('100%');
}
 
  // review form show and hide js
  $('.writeReview').click(function(){
   $('.review-form').toggleClass('review-form-show');
    if($('.review-form').hasClass("review-form-show")){
      $('.btn.writeReview').text('Close Review');
    }else{
      $('.btn.writeReview').text('Write Review');
    }
  })

//   /***************************sticky atc button product page *************************/
//        $(window).scroll(function(){
//          if($(window).width() < 718){
//             if ($(window).scrollTop() > 850 ) {
//               $(".button-container").addClass('visible');
//               $(".scrollup").show();
//             }
//             else{
//               $(".scrollup").hide();
//             }  
//           }
//         });
//  /*************************** end sticky atc button product page *************************/
  /***************************sticky atc button product page *************************/
  $(window).scroll(function(){
    if($(window).width() < 718){
       // if ($(window).scrollTop() > 1510 ) {
         $(".sticky-atc-btn-product").show();
         $(".scrollup").show();

       // }
       // else{
       //   $(".sticky-atc-btn-product").hide();
       //   $(".scrollup").hide();
       // }  
   }
   });
/*************************** end sticky atc button product page *************************/

   /***************************clivk sticky atc button show varians  *************************/
     $('body').on('click','.show-varient',function(){
    // $(".custom-model-main").addClass('model-open');
      var container = $('.template-product');
             var scrollTo = $('.product-single__form');
             var position = scrollTo.offset().top
				- container.offset().top
				+ container.scrollTop()-120;
      $('body#news,html').animate({scrollTop:position}, 600);
   })

  // $('.bg-overlay').click(function(){
  //    $(".custom-model-main").removeClass('model-open');
  // })


  $('.sticky-add-button').click(function(){
   var productVID = $(this).attr('dataV-id');
   var vidata = {quantity:1,id:productVID};
    // add to cart
   jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: vidata,
          dataType: 'json',
          success: function(cart)
       {
         $.getJSON('/cart.json', function(data){
         var item_count = data.item_count;
          $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
        });
      $('.custom-model-main').removeClass('model-open');
      var cart = new theme.CartDrawer
      cart.init()
      cart.open();
          }
        });
    // End add to cart
  })

  $('body').on('click','.addSingleProduct',function(){
   var productVID = $(this).attr('dataV-id-cart');
   var vidata = {quantity:1,id:productVID};
    // add to cart
   jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: vidata,
          dataType: 'json',
          success: function(cart)
       {
         $.getJSON('/cart.json', function(data){
         var item_count = data.item_count;
          $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
        });
      $('.custom-model-main').removeClass('model-open');
      var cart = new theme.CartDrawer
      cart.init()
      cart.open();
          }
        });
    // End add to cart
  })

  $('body').on('click','.withoutSIzeVariants',function(){
   var productVID = $(this).attr('vid-product-id');
   var vidata = {quantity:1,id:productVID};
    // add to cart
   jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: vidata,
          dataType: 'json',
          success: function(cart)
       {
         $.getJSON('/cart.json', function(data){
         var item_count = data.item_count;
          $('.cart-link__bubble.cart-link__bubble--visible').text(item_count);
        });
      $('.custom-model-main').removeClass('model-open');
      var cart = new theme.CartDrawer
      cart.init()
      cart.open();
          }
        });
    // End add to cart
  })
  
 $('body').on('click','#product-add-to-cart_drawer',function(){
   // $(this).parents('.crosscell_items').find('.custom-model-main').show();
 })
  
  // siilar products on pdp page
   $('.customSliderSimiler').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite:false,
    dots: true,
    arrows: true,
    autoplay: false,
    prevArrow: '<button class="slide-arrow prev-arrow left-arrow-style"></button>',
    nextArrow: '<button class="slide-arrow next-arrow right-arrow-style"></button>', 
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
});

  $('.customSliderSimiler').on('afterChange', function (event, slick, currentSlide) {
  const prevArrow = $('.prev-arrow');
  const nextArrow = $('.next-arrow');

  // Enable or disable the arrows based on the current slide
  if (currentSlide === 0) {
    prevArrow.attr('disabled', true);
    nextArrow.attr('disabled', false);
  } else if (currentSlide === slick.slideCount - 1) {
    prevArrow.attr('disabled', false);
    nextArrow.attr('disabled', true);
  } else {
    prevArrow.attr('disabled', false);
    nextArrow.attr('disabled', false);
  }
});

  if ($('.customSliderSimiler').length > 0) {
    $('.grid__item').removeClass('medium-up--one-quarter');   
  }
 
  // ------------------VIEW MORE IN ACCORD-------------------

  $('.legal_details').click(function () {
    $('.view_legal_details').toggle();
  });
})


// product-form js
document.addEventListener("DOMContentLoaded", (event) => {

  const acc_headings = document.querySelectorAll('.accordian_heading');

  acc_headings.forEach((acc_heading) => { 
      const acc_text = acc_heading.nextElementSibling;
      const all_acc_texts = document.querySelectorAll('.accordian_text');
      const all_acc_items = document.querySelectorAll('.accordian_item');
    acc_heading.addEventListener('click', () => {
      if (acc_text.style.display === 'block') {
        acc_text.style.display = 'none';
        acc_heading.closest('.accordian_item').classList.remove('active');
      } else {
        all_acc_texts.forEach((text) => {
          text.style.display = 'none';
        });
        acc_text.style.display = 'block';

        all_acc_items.forEach((item) => {
          item.classList.remove('active');
        });
        acc_heading.closest('.accordian_item').classList.add('active');
      }
    });
    // Automatically open the accordion with the heading "Offers" by default
    const headingText = acc_heading.querySelector('p').textContent.trim().toLowerCase();
    if (headingText === 'offers') {
      acc_text.style.display = 'block';
      acc_heading.closest('.accordian_item').classList.add('active');
    }
  });
});

// lightning deal CountDown
class CountDownPdp extends HTMLElement {
  constructor() {
    super();
    this.initCountDown()
  }
  initCountDown() {
    this.endYear = this.dataset.endyear || 2026;
    this.endMonth = this.dataset.endmonth || 0;
    this.endDay = this.dataset.endday || 1;
    this.endHour = this.dataset.endhour || 0;
    this.endMinute = this.dataset.endminute || 0;
    this.countdownFormat = this.dataset.countdownformat || `Offer ends in {days}days {hours}hrs {minutes}mins {seconds}sec`;

    let countDownDate = new Date(this.endYear, this.endMonth, this.endDay, this.endHour, this.endMinute).getTime();

    // Update the count down every 1 second
    let offerCountDownData = {}

    offerCountDownData.countDownFunction = setInterval(() => {

      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.innerHTML = this.countdownFormat.replace('{days}', days).replace('{hours}', hours).replace('{minutes}', minutes).replace('{seconds}', seconds);
        // If the count down is finished, write some text
      if (distance < 0) {
        this.innerHTML = "FLASHSALE END";
        clearInterval(offerCountDownData.countDownFunction);
        sessionStorage.setItem('flashSaleEnded', 'true');
        flashsalecollection = true;
    
      }
    }, 1000);
  }
}
customElements.define('count-down-pdp', CountDownPdp);

// color variant slider 
  $('.product-color-grid').slick({
    slidesToShow: 6,    // Adjust the number of visible items
    slidesToScroll: 1,  // How many slides to scroll at once
    arrows: true, 
    infinite:false,  
    autoplay: false,      // Show arrows
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5, // Adjust for mobile view
          slidesToScroll: 1, 
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5, // Show 1 item on smaller screens
          slidesToScroll: 1,  
        }
      }
    ]
  });   